import { Injectable } from '@angular/core';
import html2canvas from 'html2canvas';

@Injectable()
export class HtmlToPngService {

  constructor() { }

  private async inlineImages(element: HTMLElement): Promise<void> {
    const images = Array.from(element.getElementsByTagName('img'));

    return Promise.all(images.map(img => {
      return new Promise<void>((resolve, reject) => {
        const imgUrl = img.src;
        fetch(imgUrl, { mode: 'cors' })
          .then(response => response.blob())
          .then(blob => {
            const reader = new FileReader();
            reader.onload = () => {
              img.src = reader.result as string;
              resolve();
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
          .catch(reject);
      });
    })).then(() => {});
  }

  public async convertToPng(element: HTMLElement): Promise<string> {
    await this.inlineImages(element);

    const svgData = `
      <svg xmlns="http://www.w3.org/2000/svg" width="${element.offsetWidth}" height="${element.offsetHeight}">
        <foreignObject width="100%" height="100%">
          ${new XMLSerializer().serializeToString(element)}
        </foreignObject>
      </svg>
    `;
    const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);
    const img = new Image();
    
    return new Promise<string>((resolve, reject) => {
      img.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = element.offsetWidth;
          canvas.height = element.offsetHeight;
          const ctx = canvas.getContext('2d');
          if (ctx) {
            ctx.drawImage(img, 0, 0);
            URL.revokeObjectURL(url);
            resolve(canvas.toDataURL('image/png'));
          } else {
            reject('Could not get canvas context');
          }
        } catch (e) {
          URL.revokeObjectURL(url);
          reject(e);
        }
      };
      img.onerror = (err) => {
        URL.revokeObjectURL(url);
        reject('Image load error: ' + err);
      };
      img.crossOrigin = 'anonymous'; // Ensure cross-origin handling
      img.src = url;
    });
  }

  public async convertToImage(element: HTMLElement): Promise<Blob> {
    const canvas = await html2canvas(element, { useCORS: true });
    return new Promise((resolve, reject) => {
      canvas.toBlob((blob: any) => {
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error('Canvas to Blob conversion failed'));
        }
      }, 'image/png');
    });
  }
}
